import { AppId } from '@inno-tools/container-bridge'
import { FullPageAppTemplate } from 'modules/app-registry/templates/FullPageAppTemplate'
import { useLocation, useNavigate } from 'react-router-dom'
import { useUserContext } from 'shared/hooks'

import { useAvailableApps } from '../hooks/useAvailableApps'

const IpBoxApp = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  return (
    <FullPageAppTemplate
      appId={AppId.IP_BOX}
      scope='ip_box'
      envKey={apps[AppId.IP_BOX].runtimeEnvKey}
      entryPath='./IpBoxApp'
      url={process.env.REACT_APP_IP_BOX_APP_DEV_PATH}
      appName={apps[AppId.IP_BOX].name}
      appProps={{
        user,
        initialPath: location.pathname,
        onNavigate: ({ pathname: nextPathname }: { pathname: string }) => {
          const { pathname } = location

          if (pathname !== nextPathname) {
            navigate(nextPathname)
          }
        }
      }}
    />
  )
}

export { IpBoxApp }
